export default __webpack_public_path__ + "static/digital_print3-7db5d52b331ff555c8b3c6c49da3ffc6.jpg";